import React, { Fragment, useEffect, useState } from "react";
import styled from "styled-components";
import { Copy, LoaderCircle } from "@styled-icons/boxicons-regular";
import { AddSquare } from "@styled-icons/fluentui-system-filled/AddSquare";
import {
  Address,
  BlockchainName,
  BlockchainSymbol,
  DepositMethods,
  UserWallets,
} from "../../typings";
import { capitalizeFirstLetter } from "../../utils/misc";
// import Disclaimer from "../Disclaimer";

const CopyButton = styled(Copy)`
  color: white;
`;

const GenerateNewDepositAddressButton = styled(AddSquare)`
  color: white;
`;
const LoadingIcon = styled(LoaderCircle)`
  color: white;
`;
type Args = {
  userWallets: UserWallets;
  selectedBlockchainName: BlockchainName | "";
  generateNewAddress: any;
  depositMethods: DepositMethods;
};
export default function DepositAddress({
  userWallets,
  selectedBlockchainName,
  generateNewAddress,
  depositMethods,
}: Args) {
  const generateNewAddressText = "Click to Generate New Deposit Address -->";
  const [address, setAddress] = useState<Address>("");
  const [coin, setCoin] = useState<BlockchainSymbol | "">("");
  const [generatingNewAddress, setGeneratingNewAddress] = useState(false);

  // const longFukinText = "TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT "

  function copyAddress() {
    const address = document.getElementById("address")?.innerHTML;
    navigator.clipboard.writeText(address || "null");
  }
  function init(selectedBlockchainName: BlockchainName | "") {
    setAddress("");
    setCoin("");
    for (const wallet of userWallets) {
      if (selectedBlockchainName !== wallet.blockchain.name) {
        continue;
      }
      setAddress(wallet.address);
      setCoin(wallet.blockchain.symbol);
    }
  }

  useEffect(() => {
    init(selectedBlockchainName);
  }, [selectedBlockchainName, userWallets]);
  useEffect(() => {
    init(selectedBlockchainName);
  }, []);

  function Address() {
    if (generatingNewAddress) {
      return <LoadingIcon size={"22"} className="animate-spin mx-auto" />;
    }
    return (
      <Fragment>
        <p id="address">{address || generateNewAddressText}</p>
        <button>
          {address ? (
            <CopyButton
              size={"22"}
              onClick={() => {
                copyAddress();
              }}
            />
          ) : (
            <GenerateNewDepositAddressButton
              size={"22"}
              onClick={() => {
                setGeneratingNewAddress(true);
                const depositMethod = depositMethods.find(
                  (depositMethod) =>
                    depositMethod.blockchain.name === selectedBlockchainName
                );
                generateNewAddress(depositMethod?.blockchain.type).finally(() =>
                  setGeneratingNewAddress(false)
                );
              }}
            />
          )}
        </button>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <div className="">
        {/* <Disclaimer text={longFukinText} /> */}
        <p className="text-sm text-white mt-4">
          Your {capitalizeFirstLetter(selectedBlockchainName)}{" "}
          {coin.toUpperCase()} deposit address:
        </p>
        <div className="select-all text-sm text-white border border-white rounded-lg mt-2 p-2 flex justify-between">
          <Address />
        </div>
      </div>
    </Fragment>
  );
}
